import { sha256_sync as sha256Sync } from "@ton/crypto";
import { Utf8 } from "crypto-es/lib/core";
import { TripleDES } from "crypto-es/lib/tripledes";
export const PINCODE_SALT = "architec.ton";
const encodeMnemonic = (mnemonic, salt) => TripleDES.encrypt(mnemonic, sha256Sync(salt).toString()).toString();
const decodeMnemonic = (hash, salt) => TripleDES.decrypt(hash, sha256Sync(salt).toString()).toString(Utf8);
export const encodePrivateKeyByPin = (mnemonics, pincode) => encodeMnemonic(mnemonics.join(" "), `${pincode}-${PINCODE_SALT}`);
export const decodePrivateKeyByPin = (hash, pincode) => decodeMnemonic(hash, `${pincode}-${PINCODE_SALT}`).split(" ");
//# sourceMappingURL=pincode.js.map